"use client";

import { Trans } from "@lingui/react/macro";
import Link from "next/link";
import { ArtifactAuthor } from "@/components/artifacts/artifact-author";
import { ArtifactLastUpdated } from "@/components/artifacts/artifact-datetime";
import { Badge } from "@/components/ui/badge";
import { TruncateTooltip } from "@/components/ui/truncate-tooltip";
import type { ArtifactListItem } from "@/lib/artifacts/load-artifact-list";

type ArtifactListProps = {
  items: ArtifactListItem[];
  prefix: string;
};

/** Artifact index rows with title, creator, last updated, and visibility. */
export function ArtifactList({ items, prefix }: ArtifactListProps) {
  return (
    <>
      {items.map((item) => (
        <Link
          key={item.id}
          href={`${prefix}/${item.id}`}
          className="flex items-start justify-between gap-3 px-4 py-3 transition-colors hover:bg-muted/50 md:px-6"
        >
          <div className="min-w-0 flex-1 space-y-1">
            <TruncateTooltip>
              <span className="block truncate font-medium">{item.title}</span>
            </TruncateTooltip>
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-muted-foreground">
              <ArtifactAuthor author={item.author} />
              <span
                aria-hidden
                className="hidden text-muted-foreground/60 sm:inline"
              >
                ·
              </span>
              <ArtifactLastUpdated value={item.updatedAt} />
            </div>
          </div>
          <Badge
            variant={item.shared ? "secondary" : "ghost"}
            className="shrink-0 self-start"
          >
            {item.shared ? <Trans>Shared</Trans> : <Trans>Private</Trans>}
          </Badge>
        </Link>
      ))}
    </>
  );
}
